let menuList = [
  // {
  //   name: 'Orders',
  //   icon: require('@/assets/orders-1x.png'),
  //   childrenList: [
  //     {name: 'Wholesale Order', path: '/menu', key: 'wholesale', type: 'in'},
  //     {name: 'Dropshipping Order', path: '/order/my-order', key: 'dropshipping', type: 'platform', status: true}
  //   ]
  // },
  {
    name: 'Orders',
    path: '/order/list',
    type: 'frame',
    key: 'wholesale',
    icon: require('@/assets/orders-1x.png'),
    childrenList: []
  },
  {
    name: 'Coupon',
    path: '/coupon',
    type: 'in',
    key: 'coupon',
    icon: 'https://shopvidi.oss-cn-beijing.aliyuncs.com/coupon_icon.png',
    childrenList: []
  },
  {
    name: 'My Profile',
    path: '/my-profile',
    type: 'in',
    icon: 'https://shopvidi.oss-cn-beijing.aliyuncs.com/coupon_icon.png',
    childrenList: []
  },
  {
    name: 'Service Order',
    path: '/serviceOrder',
    type: 'in',
    icon: 'https://shopvidi.oss-cn-beijing.aliyuncs.com/coupon_icon.png',
    childrenList: []
  },
  {
    name: 'Help Center',
    path: 'https://help.shopvidi.com',
    type: 'out',
    icon: 'https://shopvidi.oss-cn-beijing.aliyuncs.com/coupon_icon.png',
    childrenList: []
  },
  {
    name: 'Get Sample',
    path: 'get-sample',
    type: 'in',
    key: '',
    hidden: true,
    icon: 'https://shopvidi.oss-cn-beijing.aliyuncs.com/coupon_icon.png',
    childrenList: []
  },
  // {
  //   name: 'Online Shop',
  //   icon: require('@/assets/shop-1x.png'),
  //   childrenList: [
  //     {name: 'Link you shop', path: '/store/TsPersonalStoreList', key: 'shop', type: 'platform', status: true},
  //     {name: 'Import List', path: '/goods/import/list', key: 'import', type: 'platform', status: true},
  //     {name: 'My Prodcuts', path: '/goods/my/list', key: 'prodcut', type: 'platform', status: true}
  //   ]
  // },
  {
    name: 'Product',
    path: 'menu',
    type: 'in',
    hidden: true,
    key: 'admin-prodcut',
    icon: require('@/assets/setting-1x.png'),
    childrenList: []
  }
  // {
  //   name: 'Setting',
  //   path: '/account/platform-setting/setting-list?key=setting',
  //   status: false,
  //   type: 'platform',
  //   icon: require('@/assets/setting-1x.png'),
  //   childrenList: []
  // },
  // {
  //   name: 'Help Center',
  //   path: 'https://intercom.help/ShopVidi/en/',
  //   icon: require('@/assets/helpcenter-1x.png'),
  //   childrenList: [],
  //   type: 'out'
  // }
]

export default {
  menuList
}



// WEBPACK FOOTER //
// ./src/pages/components/menu.js